const config = {
    "local":
    {
        "auth": {
            authority: "https://login.microsoftonline.com/21942f3d-edf7-4805-9a5b-e03d208249c5",
            clientId: "2c491776-0e94-4735-b60e-c3494e8b74c0",
            redirectUri: "https://localhost:44324/spa-oidc",
            grant_type: "client_credentials",
        },
        environmentDisplayText: "NCAS Reporting Local",
        showCompareLink: true,
        showBusinessCaseCompare: true,
        app_url: "https://ncas.nexteer.app",
        api_url: "https://ncas.nexteer.app/api",
        "ej_license": "Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXlfdHVVQmdeWUB3VkE=",
        app_insights: "InstrumentationKey=bff0470d-b906-49e9-8189-a286d364cc34;IngestionEndpoint=https://eastus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=f8253217-decd-4b33-802f-14bdab67a719"
    },
    "Development":
    {
        auth: {
            authority: "https://login.microsoftonline.com/21942f3d-edf7-4805-9a5b-e03d208249c5",
            clientId: "2c491776-0e94-4735-b60e-c3494e8b74c0",
            redirectUri: "https://nxt-ncasreportingdev.nexteer.app/spa-oidc",
            grant_type: "client_credentials",
        },
        environmentDisplayText: "NCAS Reporting Development",
        displayEnvironmentHeader: true,
        showCompareLink: true,
        showBusinessCaseCompare: true,
        app_url: "https://ncas-stg.nexteer.app",
        api_url: "https://ncas-stg.nexteer.app/api",
        "ej_license": "Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXlfdHVVQmdeWUB3VkE=",
        app_insights: "InstrumentationKey=bff0470d-b906-49e9-8189-a286d364cc34;IngestionEndpoint=https://eastus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=f8253217-decd-4b33-802f-14bdab67a719"
    },
    "Test":
    {
        auth: {
            authority: "https://login.microsoftonline.com/21942f3d-edf7-4805-9a5b-e03d208249c5",
            clientId: "2c491776-0e94-4735-b60e-c3494e8b74c0",
            redirectUri: "https://nxt-ncasreportingtest.nexteer.app/spa-oidc",
            grant_type: "client_credentials",
        },
        environmentDisplayText: "NCAS Reporting Test",
        displayEnvironmentHeader: true,
        showCompareLink: true,
        showBusinessCaseCompare: true,
        app_url: "https://ncas.nexteer.app",
        api_url: "https://ncas.nexteer.app/api",
        "ej_license": "Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXlfdHVVQmdeWUB3VkE=",
        app_insights: "InstrumentationKey=bff0470d-b906-49e9-8189-a286d364cc34;IngestionEndpoint=https://eastus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=f8253217-decd-4b33-802f-14bdab67a719"
    },
    "Production":
    {
        auth: {
            authority: "https://login.microsoftonline.com/21942f3d-edf7-4805-9a5b-e03d208249c5",
            clientId: "2c491776-0e94-4735-b60e-c3494e8b74c0",
            redirectUri: "https://nxt-ncasreportingprod.nexteer.app/spa-oidc",
            grant_type: "client_credentials",
        },
        environmentDisplayText: undefined,
        displayEnvironmentHeader: false,
        showCompareLink: true,
        showBusinessCaseCompare: true,
        app_url: "https://ncas.nexteer.app",
        api_url: "https://ncas.nexteer.app/api",
        "ej_license": "Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXlfdHVVQmdeWUB3VkE=",
        app_insights: "InstrumentationKey=bff0470d-b906-49e9-8189-a286d364cc34;IngestionEndpoint=https://eastus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=f8253217-decd-4b33-802f-14bdab67a719"
    }
}

export default {
    Provider: (key) => {
        let origin = window.location.origin.toLowerCase();
        let env = "local";

        if (origin.indexOf("nxt-ncasreportingprod.nexteer.app") != -1) {
            env = "Production";
        }

        if (origin.indexOf("nxt-ncasreportingtest.nexteer.app") != -1) {
            env = "Test";
        }

        if (origin.indexOf("nxt-ncasreportingdev.nexteer.app") != -1) {
            env = "Development";
        }

        return config[env][key];
    }
}